import { render, staticRenderFns } from "./DataXueYa.vue?vue&type=template&id=7a92ccca&"
import script from "./DataXueYa.vue?vue&type=script&lang=js&"
export * from "./DataXueYa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports